import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43603a4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stack-list padded-height" }

import GlitchedText from "@/components/GlitchedText.vue";
import ContentPage from "../ContentPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StackView',
  setup(__props) {

const stackArray = [
  "JavaScript",
  "TypeScript",
  "Vue",
  "Nuxt",
  "CSS",
  "SASS",
  "NPM/YARN",
  "Axios",
  "JQuery",
  "HTML",
  "PHP",
  "Yii2",
  "Bootstrap",
  "ESlint",
  "Prettier",
  "Postman",
  "JSON",
  "MySql/MariaDB",
  "WSL2",
  "Bash",
  "Github",
];

return (_ctx: any,_cache: any) => {
  const _directive_glitched = _resolveDirective("glitched")!

  return (_openBlock(), _createBlock(ContentPage, {
    full: true,
    class: "content-page__stack"
  }, {
    full: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stackArray, (stack, index) => {
          return _createElementVNode("div", {
            key: index,
            class: "stack"
          }, [
            _withDirectives(_createElementVNode("p", null, null, 512), [
              [_directive_glitched, stack]
            ])
          ])
        }), 64))
      ])
    ]),
    lower: _withCtx(() => []),
    _: 1
  }))
}
}

})